import Vue from 'vue';
import {Vue as _Vue} from "vue/types/vue";
import {VSelect} from "vuetify/lib";

const select = VSelect as unknown as typeof _Vue;

export default Vue.extend({
	name: 'AsiSelect',
	extends: select,
	props: {
		hideDetails: {
			type: String,
			default: 'auto',
		},
		filled: {
			type: Boolean,
			default: true,
		},
	},
});
